import {useMemo, useRef, useState,useEffect} from "react";
import {Box, FormControl, Slide, Snackbar} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";
import useLogout from "../../../hooks/useLogout";
import {useLingui,} from "@lingui/react";
import {Controller, useForm} from "react-hook-form";
import {Alert, Divider, Grid, InputLabel, MenuItem, Paper, Select, Typography, useTheme} from "@mui/material/";
import useHttp from "../../../hooks/useHttp";
import httpReq from "../../../ce-services/http-req";
import {msg, Trans} from '@lingui/macro'
import UserControls from "../../desktop/UserControls";
import StatisticsFilterPanel from "../StatisticsFilterPanel";
import EChart from "./EChart";
import {getColumnsModel} from "../../../pages/Statistics/utils";


const baseSelectFieldSx = (theme, isDark) => ({
    backgroundColor: isDark ? theme.palette.newColors.lightGray : "#f5f5f5",
    color: isDark ? theme.palette.newColors.gray : "#3C3C3B",
    borderRadius: 1,
    "& label": {
        color: theme.palette.newColors.gray,
    },

    "& .MuiSelect-select": {
        color: isDark ? theme.palette.newColors.gray : "#3C3C3B",
    },
    '& .MuiOutlinedInput-root':{
        color:theme.palette.newColors.gray,
    },
    "& .MuiSelect-icon": {
        color: theme.palette.newColors.gray
    },
    "& fieldset": { border: "none" },
    "&:hover fieldset": { border: "none" },
    "&.Mui-focused fieldset": { border: "none" },
});

const CustomChart = ({
                          isMobile
                      }) => {

    const navigate = useNavigate()
    const location = useLocation()
    const logout = useLogout()
    const {_} = useLingui()
    const state = location.state
    const token = state?.token || null
    const init = useMemo(() => state?.init || {}, [state?.init])
    const fieldsMethods = useForm({
        defaultValues: {reportType: null, target: null, fieldName: null, groupingModel: []}
    })
    const [user, setUser] = useState({})
    const theme = useTheme()
    const drawerWidth = theme.mixins.drawerWidth
    const {sendRequest, error} = useHttp()
    const [formModel, setFormModel] = useState({})
    const [formList, setFormList] = useState([])
    const [columnGroupingModel, setColumnGroupingModel] = useState([]);
    const [chartReportTypeItems, setChartReportTypeItems] = useState([]);
    const [chartTargetItems, setChartTargetItems] = useState([]);
    const [chartFieldItems, setChartFieldItems] = useState([]);
    const [chartData, setChartData] = useState(null);
    const [canChangeReportType, setCanChangeReportType] = useState(false);
    const [canAnalize, setCanAnalize] = useState(null);
    const [message, setMessage] = useState('')
    const submitRef = useRef();

    const isDark = theme.palette.mode === "dark";

    useEffect(() => {
        if (!token) return logout()
        if (isMobile) return navigate('/home', {state: {token, init}})
    }, [token, logout, isMobile, navigate, init])

    useEffect(() => {
        const {configuration, user} = init;
        setUser(user);
        setFormModel(configuration)
        const initForms = Object.keys(configuration).sort((a, b) => configuration[a].position - configuration[b].position)
        // console.log('initforms ', initForms)
        setFormList(initForms)
        const {columnGroupingModelWOrg: columnGroupingModel} = getColumnsModel(configuration)
        // console.log('columnGroupingModel ', columnGroupingModel)
        setColumnGroupingModel(columnGroupingModel)
        let organizations = [];
        organizations = init.organizations.filter(o => o.id !== -1).map(o => ({id: o.id, label: o.description}))
        organizations = [{id: 0, label: 'Merged'}, ...organizations]
        // console.log('organizations ', organizations)
        setChartReportTypeItems(organizations);
        const user_organization = init && init.user && init.user.organization ? init.user.organization : 0
        setCanChangeReportType(user_organization === -1)
        const init_organization = user_organization !== -1 ? user_organization : 0
        // console.log('init_organization ', init_organization)
        fieldsMethods.setValue('reportType', init_organization)
    }, [init])

    useEffect(() => {
        if (!columnGroupingModel) return;
        if (columnGroupingModel.length === 0) return;
        const arrChartFieldItems = columnGroupingModel.map(c => {
            return c.groupId
        })
        setChartTargetItems(arrChartFieldItems);
        fieldsMethods.setValue('groupingModel', columnGroupingModel)
        fieldsMethods.setValue('formModel', formModel)
    }, [columnGroupingModel])

    const handleFilterSubmit = (searchParams) => {
        console.log('aaaa ')
        console.log('searchParams custom chart ---> ', searchParams)
        const statSearchParams =
            Object.entries(searchParams).map(e => {
                return {
                    name: e[0],
                    value: e[1]
                }
            });
        const fieldData = fieldsMethods.getValues();
        const payloadData = {...fieldData}
        delete payloadData.groupingModel;
        delete payloadData.formModel;
        const payload = {
            filters: statSearchParams,
            chartField: payloadData,
            fields: init.configuration
        }
        httpReq('/AdamsStats/GetChartData', 'POST', payload, true).then(res => {
            console.log('getChartData', res)
            if (res.responseAnyError) {
                setMessage(_(msg`${res.responseMessage}`))
                setChartData(null);
                return
            }
            ;
            const fieldCompleteName = fieldData.target + ' - ' + fieldData.fieldName;
            let resData = res.responseData;
            const foundGroup = fieldData.formModel[fieldData.target];
            if (!foundGroup) return;
            const foundField = foundGroup.elements.find(f => {
                return f.label == fieldData.fieldName
            })
            if (!foundField) return;
            const foundOptions = foundField.options;
            if (foundOptions.length !== 0) {
                const newResData = foundOptions.map((opt) => {
                    const foundValue = resData.find(r => {
                        return r.label == opt.value.toString()
                    })
                    return {
                        label: opt.label,
                        value: (foundValue) ? foundValue.value : 0
                    }
                })
                resData = [...newResData];
            }
            const mappedResData = resData.map((opt, idx) => {
                if (!!opt.otherFormats) {
                    const foundValue = opt.otherFormats[0]
                    return {
                        ...opt,
                        label: foundValue.value,
                    }
                } else {
                    return opt
                }
            })
            let result = []
            mappedResData.reduce(function (res, value) {
                if (!res[value.label]) {
                    res[value.label] = {label: value.label, value: 0};
                    result.push(res[value.label])
                }
                res[value.label].value += value.value;
                return res;
            }, []);

            const chart = {
                data: result
                , title: _(msg`Custom chart for`) + ' ' + fieldCompleteName
                , type: 'bar' // [bar, line, pie]
                // , xLabel: fieldCompleteName
                // , xLabelStyle: {transform: 'translateY(200px)'}
                , yLabel: _(msg`Count`)
                , tickPlacement: 'middle'
                , tickLabelPlacement: 'middle'
                , tickLabelStyle: {
                    angle: 45
                    , textAnchor: 'start'
                    , fontSize: 12
                }
                , margin: {bottom: 350, right: 150}
                , colorMap: {
                    type: 'ordinal'
                    , colors: [
                        '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd',
                        '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf',
                        '#393b79', '#637939', '#8c6d31', '#843c39', '#7b4173',
                        '#17a768', '#f28e2b', '#4e79a7', '#e15759', '#76b7b2',
                        '#59a14f', '#edc949', '#af7aa1', '#ff9da7', '#9c755f',
                        '#bab0ab', '#6b6ecf', '#b07aa1', '#ffbf00', '#1b9e77'
                    ]
                }
                // , tickLabelStyle: {
                //     angle: 45
                //     , textAnchor: 'start'
                //     , fontSize: 12
                // }
                // , margin: {bottom:250, right: 150}
            };
            setChartData(chart);
        })
    }

    const handleFilterReset = () => {
        fieldsMethods.setValue('target', null)
        fieldsMethods.setValue('fieldName', null)
        setChartData(null);
    }

    const onFieldFormSubmit = (data) => {
        console.log(data);
    }

    useEffect(() => {
        const {unsubscribe} = fieldsMethods.watch((value, {type}) => {
            if (type === 'change') {
                const currentValues = fieldsMethods.getValues();
                const selectedTarget = currentValues.target;
                const selectedField = currentValues.fieldName;

                if (!selectedTarget || !currentValues.groupingModel || currentValues.groupingModel.length === 0) {
                    setChartFieldItems([]);
                } else {

                    const found = currentValues.groupingModel.find(c => {
                        return c.groupId == selectedTarget
                    })
                    const v = found.children
                    const values = Object.values(v).map(v => {
                        return v.field
                    }).filter(v => {
                        return v !== 'organization'
                    })
                    setChartFieldItems(values);
                }
                (selectedTarget && selectedField) ? setCanAnalize(true) : setCanAnalize(false);
            }
        });
        return () => unsubscribe();
    }, [fieldsMethods.getValues, fieldsMethods.watch]);

    const handleChartTypeChange = (event) => {
        const newChartData = {
            ...chartData,
            type: event.target.value
        }
        setChartData(newChartData);
    }

    function SlideTransition(props) {
        return <Slide {...props} direction="up"/>
    }

    return (
        <Box
            ml={`${drawerWidth}px`}
            mb={4}
            pl={2}
            pr={2}
            display='flex'
            flexDirection='column'
            alignItems='center'

            sx={{
                '& .overload-header': {
                    backgroundColor: theme.palette.primary.main
                    , color: theme.palette.primary.contrastText
                }
            }}
        >
            {/*
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                padding: 1.5
            }}>
                <Typography sx={{fontSize: 18}} variant="h3">
                    <Trans>Custom chart</Trans>
                </Typography>
                <Box sx={{alignSelf: 'end'}}>
                    <UserControls noElev={true} state={state}/>
                </Box>
            </Box>
            <Divider flexItem/>
            */}
            <Grid container spacing={2} sx={{marginTop: 0}}>
                <Grid item xs={12} lg={3}>
                    {chartTargetItems.length > 0 && (
                        <Paper square sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            mt: 1,
                            gap: 2,
                            pt: 3,
                            pb: 3,
                            pl: 2,
                            pr: 2,
                            minHeight: 350
                        }}>
                            <Box display='flex' justifyContent='space-between' alignItems='baseline'>
                                <Typography
                                    sx={{
                                        color: theme.palette.mode === "light" ? theme.palette.newColors.gray : theme.palette.newColors.lightGray,
                                        fontWeight: 600,
                                    }}
                                    variant="h5"
                                >
                                    <Trans>Field to analyze</Trans>
                                </Typography>
                            </Box>
                            <Divider flexitem sx={{mt: -1}}/>
                            <Box
                                component="form"
                                ref={submitRef}
                                onSubmit={fieldsMethods.handleSubmit(onFieldFormSubmit)}
                                display='flex'
                                gap={2}
                                pr={2}
                                noValidate
                            >
                                <Grid container spacing={0}>
                                    <Grid item xs={12}>
                                        <Box width='100%'>
                                            <FormControl key={'cc-report-type-form-control'} margin='dense'
                                                         fullWidth>
                                                <InputLabel id={'cc-report-type-input-label'}>Report
                                                    Type</InputLabel>
                                                <Controller
                                                    name={'reportType'}
                                                    control={fieldsMethods.control}
                                                    render={({field}) => (
                                                        <Select
                                                            sx={{
                                                                ...baseSelectFieldSx(theme, isDark),
                                                                "&:hover": { backgroundColor: "inherit" }, // no hover white
                                                            }}
                                                            {...field}
                                                            labelId='report-type-label'
                                                            id='report-type-label'
                                                            label={'Report Type'}
                                                            value={field.value}
                                                            onChange={field.onChange}
                                                            fullWidth
                                                            disabled={!canChangeReportType}
                                                        >
                                                            {chartReportTypeItems.map(opt => {
                                                                return <MenuItem key={`cc-report-type-${opt.id}`}
                                                                                 value={opt.id}>{opt.label}</MenuItem>
                                                            })}
                                                        </Select>
                                                    )}
                                                />
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box width='100%'>
                                            <FormControl key={'cc-target-form-control'} margin='dense' fullWidth>
                                                <InputLabel id={'cc-target-input-label'}>Form</InputLabel>
                                                <Controller
                                                    name={'target'}
                                                    control={fieldsMethods.control}
                                                    render={({field}) => (
                                                        <Select
                                                            sx={{
                                                                ...baseSelectFieldSx(theme, isDark),
                                                                "&:hover": { backgroundColor: "inherit" }, // no hover white
                                                            }}
                                                            {...field}
                                                            labelId='target-label'
                                                            id='target-label'
                                                            label={'Form'}
                                                            value={field.value}
                                                            onChange={field.onChange}
                                                            fullWidth
                                                        >
                                                            {chartTargetItems.map(opt => {
                                                                return <MenuItem key={`cc-target-${opt}`}
                                                                                 value={opt}>{opt}</MenuItem>
                                                            })}
                                                        </Select>
                                                    )}
                                                />
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box width='100%'>
                                            <FormControl key={'cc-field-form-control'} margin='dense' fullWidth>
                                                <InputLabel id={'cc-field-input-label'}>Field</InputLabel>
                                                <Controller
                                                    name={'fieldName'}
                                                    control={fieldsMethods.control}
                                                    render={({field}) => (
                                                        <Select
                                                            sx={{
                                                                ...baseSelectFieldSx(theme, isDark),
                                                                "&:hover": { backgroundColor: "inherit" }, // no hover white
                                                            }}
                                                            {...field}
                                                            labelId='field-label'
                                                            id='field-label'
                                                            label={'Field'}
                                                            value={field.value}
                                                            onChange={field.onChange}
                                                            fullWidth
                                                        >
                                                            {chartFieldItems.map(opt => {
                                                                return <MenuItem key={`cc-field-${opt}`}
                                                                                 value={opt}>{opt}</MenuItem>
                                                            })}
                                                        </Select>
                                                    )}
                                                />
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Paper>
                    )}
                </Grid>
                <Grid item xs={12} lg={9}>
                    {formList.length > 0 && (
                        <StatisticsFilterPanel
                            newLabel={'Custom charts'}
                            title={"Custom charts"}
                            formList={formList}
                            filterDisabled={!canAnalize}
                            onFilterSubmit={handleFilterSubmit}
                            onFilterReset={handleFilterReset}
                            setDataLoaded={null}
                            setFilters={null}
                            user={user}
                            formModel={formModel}
                            isMobile={isMobile}
                        />
                    )}

                </Grid>
                <Grid item xs={12} lg={12}>
                    <Box p={2} key={'custom-chart-box'} width='100%' display='flex'>
                        {/* First column */}
                        {chartData &&
                            <EChart chart={chartData} index={0} handleCharts={handleChartTypeChange} width='100%'/>}
                    </Box>
                </Grid>
            </Grid>
            <Snackbar
                open={message !== ''}
                autoHideDuration={5000}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                TransitionComponent={SlideTransition}
                onClose={(_, reason) => {
                    if (reason === 'clickaway') {
                        return
                    }
                    setMessage('')
                }}>
                <Alert variant='filled' severity='error' sx={{width: '100%'}}>{message}</Alert>
            </Snackbar>
        </Box>
    )
}

export default CustomChart